<script setup lang="ts">
import stores from '@jaaluu/stores';
import NumberFlow from '@number-flow/vue';
import { t } from '@shared/i18n';
import sharedStores from '@shared/shared-stores';
import { computed, onMounted, ref, watch } from 'vue';

const { addConfetti } = sharedStores.animate.funcs;
const { showAnimateWord } = stores.favorites.state;

const newLevel = ref(0);
const baseUrl = (import.meta as any).env.VITE_JAALUU_API_URL;
const success = new Audio(`${baseUrl}/v1/file/sounds/success_long.mp3`);

const celebrateMessage = computed(() => {
  const message = t('favorites.success_level_up_celebrate');
  return message.replace(
    showAnimateWord.value.word,
    `<strong class="text-green title-sm">${showAnimateWord.value.word}</strong>`
  );
});

onMounted(() => {
  animateLevelUp();
});

const animateLevelUp = () => {
  newLevel.value = showAnimateWord.value.oldLevel + 1;
  if (showAnimateWord.value.show) {
    addConfetti();
    success.play().catch((err) => console.error('Error playing success sound:', err));
  }
  setTimeout(() => {
    newLevel.value = showAnimateWord.value.newLevel + 1;
  }, 1000);
};

watch(
  () => showAnimateWord.value.show,
  () => animateLevelUp()
);
</script>

<template>
  <v-snackbar v-model="showAnimateWord.show" multi-line color="white">
    <div class="title d-flex justify-center">{{ t('general.well_done') }}</div>
    <!-- <div class="d-flex justify-center">
      <div>
        <v-img
          transition="fade-transition"
          cover
          class="img"
          :src="getImageFileUrl('family_celebrating.gif', 'course')"
        />
      </div>
    </div> -->
    <div class="d-flex flex-column align-center">
      <div class="title-md mt-2">{{ t('favorites.success_level_up_celebrate') }}</div>
      <div class="mt-6 jump-animation" v-if="showAnimateWord.show">
        <v-chip variant="tonal" color="purple" size="large">
          <span class="mr-4">{{ showAnimateWord.word }}</span>
          <v-icon size="20" color="purple" icon="mdi-arrow-up-bold" />
          <NumberFlow :value="newLevel" class="title" color="purple" />
        </v-chip>
      </div>
    </div>
  </v-snackbar>
</template>

<style scoped lang="scss">
.jump-animation {
  animation: jump 0.6s ease-in-out infinite;
}

@keyframes jump {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}
.img {
  width: 100px;
  height: 100px;
}
</style>
